<template>
  <LandingBackground>
    <div class="mb-20">
      <div class="mx-auto mt-10 grid grid-cols-1 items-start gap-10 sm:px-5 md:px-8 xl:grid-cols-2 3xl:grid-cols-3">
        <div class="flex min-w-0 flex-col gap-10">
          <LandingCard variant="info" :title="`Welcome, ${userRef.firstName} ${userRef.lastName}`">
            <template #default>
              <LandingCardLinkSections label="Emergency Response Incidents">
                <LandingCardLinkSection
                  link-label="Find Emergency Response Incidents"
                  description="Find, view, and manage hazardous substance spill and emergency response."
                  :to="{ name: routeNames.incidents.incidents }"
                />
              </LandingCardLinkSections>
              <LandingCardLinkSections label="HEPCRA Facilities">
                <LandingCardLinkSection
                  link-label="Find HEPCRA Facilities"
                  description="Find, view, and manage facilities required to report hazardous and toxic chemicals."
                  :to="{ name: routeNames.facilities.facilities }"
                />
              </LandingCardLinkSections>
              <LandingCardLinkSections label="Discovery and Remediation Sites">
                <LandingCardLinkSection
                  link-label="Find Discovery and Remediation Sites"
                  description="Find, view, and manage site identification, investigation, and remediation activities."
                  :to="{ name: routeNames.sites.sites }"
                />
              </LandingCardLinkSections>
              <Authorize permission-name="ReadInquiry">
                <LandingCardLinkSections label="Hazard Evaluation Inquiries">
                  <LandingCardLinkSection
                    link-label="Find Hazard Evaluation Inquiries"
                    description="Find, view, and manage reported pesticide and heavy metal poisoning."
                    :to="{ name: routeNames.inquiries.inquiries }"
                  />
                </LandingCardLinkSections>
                <template #pending>
                  <LandingCardSkeleton class="py-6" />
                </template>
              </Authorize>
            </template>
          </LandingCard>
        </div>
        <div class="flex min-w-0 flex-col gap-10 xl:col-start-2 3xl:contents">
          <div class="flex min-w-0 flex-col gap-10 3xl:col-start-2">
            <LandingCard title="Emergency Response Incidents" :view-all-to="{ name: routeNames.incidents.incidents }">
              <div class="bg-neutral-50 p-10 sm:rounded-b-lg">
                <NoneFoundFlag label="Coming Soon" />
              </div>
            </LandingCard>

            <LandingCard title="HEPCRA Facilities" :view-all-to="{ name: routeNames.facilities.facilities }">
              <div class="bg-neutral-50 p-10 sm:rounded-b-lg">
                <NoneFoundFlag label="Coming Soon" />
              </div>
            </LandingCard>
          </div>

          <div class="flex min-w-0 flex-col gap-10 3xl:col-start-3">
            <LandingCard title="Discovery and Remediation Sites" :view-all-to="{ name: routeNames.sites.sites }">
              <div class="bg-neutral-50 p-10 sm:rounded-b-lg">
                <NoneFoundFlag label="Coming Soon" />
              </div>
            </LandingCard>
            <Authorize permission-name="ReadInquiry">
              <LandingCard title="Hazard Evaluation Inquiries" :view-all-to="{ name: routeNames.inquiries.inquiries }">
                <div class="bg-neutral-50 p-10 sm:rounded-b-lg">
                  <NoneFoundFlag label="Coming Soon" />
                </div>
              </LandingCard>
              <template #pending>
                <SkeletonBlock class="h-40 w-full" />
              </template>
            </Authorize>
          </div>
        </div>
      </div>
    </div>
  </LandingBackground>
</template>

<script lang="ts">
import LandingCard from "@/components/landing/LandingCard.vue";
import LandingCardEntityList from "@/components/landing/LandingCardEntityList.vue";
import LandingCardEntityListItem from "@/components/landing/LandingCardEntityListItem.vue";
import LandingCardLinkSection from "@/components/landing/LandingCardLinkSection.vue";
import LandingCardLinkSections from "@/components/landing/LandingCardLinkSections.vue";
import LandingCardSkeleton from "@/components/landing/LandingCardSkeleton.vue";
import LandingBackground from "@/components/LandingBackground.vue";
import { routeNames } from "@/routes";
import { BaseButton } from "@modernary/mui/components/button";
import { NoneFoundFlag, SkeletonBlock, useAppSettingsStore } from "@modernary/mui/components/common";
import { PublicLandingList, PublicLandingListItem } from "@modernary/mui/components/publicLanding";
import { useUser } from "@modernary/mui/utils/authentication";
import { LogoutButton } from "@modernary/mui/utils/authentication/buttons";
import { Authorize } from "@modernary/mui/utils/authorization";
import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeInternal",
  components: {
    Authorize,
    LandingBackground,
    LandingCard,
    LandingCardLinkSection,
    LandingCardLinkSections,
    LandingCardEntityList,
    LandingCardEntityListItem,
    LandingCardSkeleton,
    LogoutButton,
    PublicLandingList,
    PublicLandingListItem,
    NoneFoundFlag,
    SkeletonBlock,
  },
  setup() {
    const { userRef } = useUser();
    const appSettingsStore = useAppSettingsStore();

    return {
      userRef,
      routeNames,
      BaseButton,
      appSettingsStore,
    };
  },
});
</script>
